import type { FC } from 'react'

import { Quote } from 'lucide-react'
import { Reveal } from '@/components/generals/reveal'
import { SectionHeading } from '@/components/landing/section-heading'
import { testimonials } from '@/constants/content'

const initials = (name: string) => name.split(' ').map(part => part[0]).join('').slice(0, 2)

export const Testimonials: FC = () => {
    return (
        <section id='reviews' aria-labelledby='reviews-title' className='relative z-10 scroll-mt-16 bg-background py-24 sm:py-32'>
            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <SectionHeading
                    id='reviews-title'
                    eyebrow="Customer stories"
                    title="Trusted on the floor."
                    body="Fleet managers in logistics, cold chain and building supplies on what changed after the switch."
                />

                <div className='mt-14 grid gap-4 lg:grid-cols-3'>
                    {testimonials.map((item, index) => (
                        <Reveal key={item.name} delay={index * 110} className='h-full'>
                            <figure className='flex h-full flex-col rounded-3xl border border-white/10 bg-card p-7 sm:p-8'>
                                <div className='flex items-start justify-between gap-4'>
                                    <div>
                                        <p className='font-heading font-expanded text-4xl font-extrabold text-brand'>
                                            {item.metric}
                                        </p>
                                        <p className='mt-1 text-xs text-white/55'>
                                            {item.metricLabel}
                                        </p>
                                    </div>
                                    <Quote aria-hidden='true' className='size-8 text-white/15' />
                                </div>

                                <blockquote className='mt-8 flex-1 text-base leading-relaxed text-white/85'>
                                    <p>{item.quote}</p>
                                </blockquote>

                                <figcaption className='mt-8 flex items-center gap-3 border-t border-white/10 pt-6'>
                                    <span aria-hidden='true' className='flex size-11 shrink-0 items-center justify-center rounded-full bg-white/[0.06] font-heading text-sm font-bold text-white/80'>
                                        {initials(item.name)}
                                    </span>
                                    <span>
                                        <span className='block text-sm font-semibold text-white'>{item.name}</span>
                                        <span className='block text-xs text-white/55'>
                                            {item.role}, {item.company}
                                        </span>
                                    </span>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    )
}
